import { supabase } from '../../common/config/supabase';
import { IEntry, IEntryProperty, IEntryResponse } from '../../common/interfaces/entry.interface';

export const getEntry = async (
  request_id: string,
  year_param: string,
  month_param: string,
): Promise<IEntryResponse> => {
  const { data, error } = await supabase.rpc(
    'get_entry',
    {
      month_param: +month_param,
      year_param: +year_param,
      request_id_param: +request_id,
    },
    { get: true },
  );

  if (error) {
    throw error;
  }

  return data[0];
};

export const getEntries = async (request_id?: number): Promise<IEntry[]> => {
  if (!request_id) {
    return [];
  }

  const { data, error } = await supabase
    .from('entries')
    .select('*')
    .eq('request_id', request_id)
    .limit(50000);

  if (error) {
    throw error;
  }

  return data ? data : [];
};

export const updateEntry = async (
  entry_id: number | undefined,
  request_id: number,
  year: number,
  month: number,
  properties: IEntryProperty[],
  details?: string,
) => {
  const { data: session } = await supabase.auth.getSession();

  const { data, error } = await supabase
    .from('entries')
    .upsert(
      { request_id, year, month, properties, created_by: session?.session?.user.id, details },
      { onConflict: 'request_id, year, month' },
    )
    .eq('id', entry_id)
    .select();

  if (error) {
    throw error;
  }

  return data;
};
